import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { TRANSACTION_PACKAGE_LIST } from 'src/constants/queryKeys';

// TransactionPackage

export const networkGetTransactionPackageInfo = async (id) => {
  const res = await axiosInstance.post(`TransactionPackage/Info/${id}`);
  return res;
};

export const networkGetTransactionPackageList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`TransactionPackage/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchTransactionPackageList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [TRANSACTION_PACKAGE_LIST, payload, pageIndex],
    queryFn: () => networkGetTransactionPackageList(payload, pageIndex, pageSize),
  });
}

export const networkCreateTransactionPackage = async (data) => {
  const res = await axiosInstance.post('TransactionPackage/Insert', data);
  return res;
};

export const networkUpdateTransactionPackage = async (id, data) => {
  const res = await axiosInstance.post(`TransactionPackage/Update/${id}`, data);
  return res;
};

export const networkRemoveTransactionPackage = async (id) => {
  const res = await axiosInstance.post(`TransactionPackage/Remove/${id}`);
  return res;
};

// TransactionPackageItem

export const networkGetTransactionPackageItemList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`TransactionPackageItem/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchTransactionPackageItemList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['tarnsaction-package-item-list', payload, pageIndex],
    queryFn: () => networkGetTransactionPackageItemList(payload, pageIndex, pageSize),
  });
}

export const networkCreateTransactionPackageItem = async (data) => {
  const res = await axiosInstance.post('TransactionPackageItem/Insert', data);
  return res;
};

export const networkUpdateTransactionPackageItem = async (id, data) => {
  const res = await axiosInstance.post(`TransactionPackageItem/Update/${id}`, data);
  return res;
};

export const networkRemoveTransactionPackageItem = async (id) => {
  const res = await axiosInstance.post(`TransactionPackageItem/Remove/${id}`);
  return res;
};

export const networkTransactionPackageMove = async (projectId, payload) => {
  const res = await axiosInstance.post(`TransactionPackage/Move/${projectId}`, payload);
  return res;
};
